var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.52942 1.23534C4.94871 1.23534 1.23531 4.94874 1.23531 9.52946C1.23531 14.1102 4.94871 17.8236 9.52942 17.8236C14.1101 17.8236 17.8235 14.1102 17.8235 9.52946C17.8235 4.94874 14.1101 1.23534 9.52942 1.23534ZM0.176483 9.52946C0.176483 4.36397 4.36394 0.176514 9.52942 0.176514C14.6949 0.176514 18.8824 4.36397 18.8824 9.52946C18.8824 14.6949 14.6949 18.8824 9.52942 18.8824C4.36394 18.8824 0.176483 14.6949 0.176483 9.52946Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8609 15.861C16.0677 15.6542 16.4029 15.6542 16.6096 15.861L23.6685 22.9198C23.8752 23.1266 23.8752 23.4618 23.6685 23.6685C23.4617 23.8753 23.1265 23.8753 22.9198 23.6685L15.8609 16.6097C15.6542 16.4029 15.6542 16.0677 15.8609 15.861Z",
    fill: "inherit"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.86bc38b5e18fc47693bb58ca55dfa37f.svg";
export { ForwardRef as ReactComponent };